import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'
import { FormattedMessage } from 'react-intl'
import { showErrorToast } from 'utils/toast'
import Modal from 'components/Modal'

import { requestChangeEmail } from 'api/user'
import { ModalContentContainer } from '../ProfileManagement/style'

const EmailWasChangedModal = () => {

  return (
    <ModalContentContainer>
      <FormattedMessage id={'emailWasChanged'} />
    </ModalContentContainer>
  )
}

const ChangeEmailPage = () => {
  const [showEmailModal, setShowEmailModal] = useState(false)
  const token = qs.parse(useLocation().search).token

  const changeEmailRequest = async () => {
    try {
      const response = await requestChangeEmail(token)

      if (response.error) {
        showErrorToast(<FormattedMessage id={response.error} />, 'showBorder')
      } else {
        setShowEmailModal(true)
      }
    } catch (e) {
      showErrorToast(<FormattedMessage id='somethingWentWrong' />, 'showBorder')
    }
  }

  useEffect(() => {
    changeEmailRequest()
  }, [])

  return <div>
    <Modal isOpen={showEmailModal} toggleModal={setShowEmailModal} modalTitleId='emailChanged' >
      <EmailWasChangedModal />
    </Modal>
  </div>

}

export default ChangeEmailPage
